module.exports = __webpack_public_path__ + "static/media/fairy_4.4891bcf0.jpg";